import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "login" }
const _hoisted_2 = { class: "wrapper wrapper-login" }
const _hoisted_3 = { class: "container container-login animated fadeIn" }
const _hoisted_4 = { class: "text-center" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "app-brand-text menu-text fw-bold ms-2" }
const _hoisted_7 = ["src"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h3", { class: "text-center mt-4" }, "Sign In To Customer Portal", -1)
const _hoisted_9 = { class: "login-form" }
const _hoisted_10 = { class: "form-group" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h6", { style: {"margin-bottom":"0"} }, "Email", -1)
const _hoisted_12 = { class: "form-group form-floating-label mt-3" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h6", { style: {"margin-bottom":"0"} }, "Password", -1)
const _hoisted_14 = { class: "form-action mb-3" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "login-account" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "forget-password",
    id: "show-signup",
    class: "link"
  }, "Forget Password")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("body", null, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", null, [
              _createElementVNode("img", {
                src: _ctx.url + 'assets/img/customer-portal/logo-saat.png',
                alt: "Logo - Saat",
                width: "74",
                height: "81"
              }, null, 8, _hoisted_5)
            ]),
            _createElementVNode("span", _hoisted_6, [
              _createElementVNode("img", {
                src: _ctx.url + 'assets/img/customer-portal/logo-saat-text.png',
                alt: "Logo - Saat",
                width: "100",
                height: "82"
              }, null, 8, _hoisted_7)
            ])
          ]),
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _withDirectives(_createElementVNode("input", {
                id: "email",
                name: "email",
                type: "text",
                class: "form-control input-border-bottom mt-2",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.loginData.email) = $event)),
                required: ""
              }, null, 512), [
                [_vModelText, _ctx.loginData.email]
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _withDirectives(_createElementVNode("input", {
                id: "password",
                name: "password",
                type: "password",
                class: "form-control input-border-bottom mt-2",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.loginData.password) = $event)),
                required: ""
              }, null, 512), [
                [_vModelText, _ctx.loginData.password]
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("a", {
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args))),
                class: "btn btn-primary btn-rounded btn-login"
              }, "Sign In")
            ]),
            _hoisted_15
          ])
        ])
      ])
    ])
  ]))
}